// FormControlEmployee component

import { useEffect } from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Spinner,
  Flex,
  Text,
  Avatar,
} from "@chakra-ui/react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  newBorder,
  white,
  primary,
  textPrimary,
  textSecondary,
  hoverItemColor,
  color8,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { listEmployeesAllSimple } from "../../actions/employeeActions";
import { useParams } from "react-router-dom";
import { shade } from "polished";

const FormControlEmployee = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  isSmall,
  isMulti,
  placeholder,
  noBottom,
  mb,
  labelFontSize,
}) => {
  // TRANSLATION
  const { slug } = useParams();
  const { t } = useTranslation();

  const animatedComponents = makeAnimated();

  // REDUX
  const dispatch = useDispatch();
  const employeeListSimple = useSelector((state) => state.employeeListSimple);
  const { loading, error, employees } = employeeListSimple;

  useEffect(() => {
    // Dispatch the action with fetchAll set to true
    dispatch(listEmployeesAllSimple(slug));
  }, [dispatch, slug]);

  // Convert fetched states into format for react-select
  const employeeOptions = employees.map((employee) => ({
    value: employee._id,
    label: employee.firstName + " " + employee.lastName,
  }));

  // Map each value to its corresponding option object
  // const selectedOption = Array.isArray(value)
  //   ? value.map((val) => employeeOptions.find((opt) => opt.value === val))
  //   : [];

  // Map each value to its corresponding option object or find a single matching option
  // Correctly handle both single and multi-select scenarios
  const selectedOption = isMulti
    ? (Array.isArray(value) ? value : []).map((val) =>
        employeeOptions.find((opt) => opt.value === val)
      )
    : employeeOptions.find((opt) => opt.value === value) || null;

  // Custom rendering for options and selected values
  const formatOptionLabel = (option, { context }) => (
    <Flex
      align="center"
      w="initial"
      // bg={context === "menu" ? option.bg : "inherit"}
    >
      <Flex align="center" h="100%">
        <Avatar
          h={["2.5rem", "2rem", "1.5rem"]}
          w={["2.5rem", "2rem", "1.5rem"]}
          fontSize="xs"
          name={option.label}
          // bg="#dceeff"
          // color="#3a74a9"
          bg={color8}
          color={white}
          mr="0.5rem"
        />

        {/* <Text
          fontSize="md"
          fontWeight="500"
          color={textPrimary}
          maxW="280px"
          isTruncated
        >
          {option.lastName}{" "}
          <Text as="span" fontWeight="400">
            {option.firstName}
          </Text>
        </Text> */}
      </Flex>

      <Text
        fontSize={context === "menu" ? "13px" : "sm"}
        fontWeight="500"
        maxW="280px"
        isTruncated
        // color={context === "menu" ? textSecondary : option.color}
      >
        {option.label}
      </Text>
    </Flex>
  );

  // // Custom rendering for options
  // const formatOptionLabel = ({
  //   firstName,
  //   lastName,
  //   profession,
  //   birthDate,
  //   status,
  // }) => (
  //   <Flex align="center" justify="space-between" w="100%" h="100%" p="0 0.5rem">
  //     <Flex align="center" h="100%">
  //       <Avatar
  //         h={["2.5rem", "2rem", "1.5rem"]}
  //         w={["2.5rem", "2rem", "1.5rem"]}
  //         fontSize="xs"
  //         name={`${lastName} ${firstName}`}
  //         // bg="#dceeff"
  //         // color="#3a74a9"
  //         bg={color8}
  //         color={white}
  //         mr="0.5rem"
  //       />

  //       <Text
  //         fontSize="md"
  //         fontWeight="500"
  //         color={textPrimary}
  //         maxW="280px"
  //         isTruncated
  //       >
  //         {lastName}{" "}
  //         <Text as="span" fontWeight="400">
  //           {firstName}
  //         </Text>
  //       </Text>
  //     </Flex>

  //     <Flex justify="flex-end" align="center">
  //       <Text
  //         fontSize="0.8rem"
  //         color={textSecondary}
  //         fontWeight="500"
  //         mr="0.5rem"
  //       >
  //         {profession && profession !== "null" ? profession.name : "-"}
  //       </Text>
  //     </Flex>

  //     {/* <StatusBadge isSmall options="user" status={status} ml={2} /> */}
  //   </Flex>
  // );

  // Custom styles for react-select
  // const customStyles = {
  //   control: (baseStyles, state) => ({
  //     ...baseStyles,
  //     borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
  //     borderRadius: "1rem",
  //     backgroundColor: white,
  //     border: `1px solid ${newBorder}`,
  //     fontSize: isSmall ? "0.875rem" : "0.938rem",
  //     fontWeight: "500",
  //     minHeight: isSmall ? "2.5rem" : "3rem",
  //     height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
  //     padding: "0 0rem",
  //     ":focus-visible": {
  //       borderColor: primary,
  //       boxShadow: `0 0 0 1px ${newBorder}`,
  //     },
  //     ":hover": {
  //       cursor: "pointer",
  //     },
  //   }),

  //   singleValue: (provided, state) => ({
  //     ...provided,
  //     opacity: state.isDisabled ? 0.5 : 1,
  //     color: textPrimary,
  //     ":hover": {
  //       bg: "red",
  //     },
  //   }),

  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? primary : null,
  //     color: state.isFocused ? white : state.data.color,
  //     cursor: "pointer",
  //     display: "flex",
  //     alignItems: "center",
  //   }),
  //   multiValue: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: primary,
  //     color: white,
  //     borderRadius: "0.75rem",
  //     fontSize: "0.938rem",
  //   }),
  //   multiValueLabel: (provided, state) => ({
  //     ...provided,
  //     color: state.data.color,
  //   }),
  //   multiValueRemove: (provided, state) => ({
  //     ...provided,
  //     ":hover": {
  //       backgroundColor: state.data.bgDark,
  //       color: state.data.color,
  //     },
  //   }),
  //   groupHeading: (provided) => ({
  //     ...provided,
  //     fontSize: "11px",
  //     color: textSecondary,
  //     fontWeight: "500",
  //   }),
  // };

  // Custom styles for react-select
  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: "#718096", // Change this to your desired placeholder color
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: isSmall ? "2.5rem" : "3rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      margin: "0",
      padding: "0 8px",
      borderRadius: "0.75rem",

      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
      ":hover": {
        boxShadow: "none",
        outline: "none",
        cursor: "pointer",
        borderColor: "#cbd5e0",
      },
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
      border: `0px solid ${newBorder}`,
      overflow: "hidden",
      zIndex: 90000,
    }),

    menuList: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      border: "none",
      boxShadow: "none",
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      margin: "0",
      padding: "0 0px",

      ":hover": {
        bg: "red",
      },
    }),

    option: (provided, state) => ({
      ...provided,

      // backgroundColor: state.isFocused ? backgroundLight : null,
      backgroundColor: state.isSelected ? primary : white, // Background color of selected option
      // color: state.isFocused ? textPrimary : state.data.color,
      color: state.isSelected ? "white" : textSecondary, // Color of text in options
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      margin: "0",
      padding: "0 1rem",
      fontWeight: "500",
      height: "48px",
      fontSize: "0.875rem",
      borderBottom: `1px solid ${newBorder}`,
      ":hover": {
        backgroundColor: state.isSelected
          ? shade(0.1, primary)
          : hoverItemColor,
        color: state.isSelected ? "white" : textPrimary,
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: primary,
      color: white,
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: state.data.bgDark,
        color: state.data.color,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  // console.log("employees", employees);
  // console.log("employeeOptions", employeeOptions);

  // console.log("value", value);
  // console.log("selectedOption", selectedOption);

  // Loading and error handling can be implemented as needed
  if (loading) return <Spinner color={primary} size="lg" />;
  if (error) return <div>Error: {error}</div>;

  return (
    <FormControl
      mb={mb ? mb : 4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel
        fontSize={labelFontSize ? labelFontSize : "sm"}
        position="relative"
      >
        {label}
        {isError && isTouched && (
          <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
        )}
      </FormLabel>
      <Select
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti} // ✅ Close on select if not multi
        components={animatedComponents}
        formatOptionLabel={formatOptionLabel}
        value={selectedOption}
        onChange={onChange}
        options={employeeOptions}
        placeholder={placeholder}
        styles={customStyles}
      />
    </FormControl>
  );
};

export default FormControlEmployee;
